import {I18nProvider} from '@lingui/react';
import {ConfigProvider} from 'antd';
import React from 'react';
import {connect, Provider as StoreProvider} from 'react-redux';
import './index.less';
import en_GB from 'antd/lib/locale/en_GB';
import hu_HU from 'antd/lib/locale/hu_HU';
import ja_JP from 'antd/lib/locale/ja_JP';
import LoginPage from './screens/login-page'
import ReactDOM from "react-dom";
import store from "./store";
import DrawerProvider from "./utils/drawer-provider";

const locales = {
    en: en_GB,
    hu: hu_HU,
    ja: ja_JP,
};

const catalogs = {
    en: require('./assets/locale/en/messages').default,
    hu: require('./assets/locale/hu/messages').default,
    ja: require('./assets/locale/ja/messages').default,
};

require('moment/locale/hu');
require('moment/locale/ja');

const mapState = ({locale}: any) => ({locale});

const LocaledApp = connect(mapState)(({locale}) => (
        <ConfigProvider locale={locales[locale]}>
            <I18nProvider language={locale} catalogs={catalogs}>
                <LoginPage/>
            </I18nProvider>
        </ConfigProvider>
    ),
);

ReactDOM.render((
    <StoreProvider store={store}>
        <DrawerProvider>
            <LocaledApp/>
        </DrawerProvider>
    </StoreProvider>
), document.getElementById('root'));
